import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

export default function IconButton({
    icon,
    label,
    onClick = undefined,
    variant = "confirm",
    size = 42,
    disabled = false,
    className = "",
    type = "button",
}) {
    return (
        <button
            type={type}
            className={classNames("icon-button", `icon-button--${variant}`, className)}
            onClick={onClick}
            aria-label={label}
            disabled={disabled}
            style={{ width: size, height: size }}
        >
            <span className="icon-button__icon" aria-hidden="true">
                {icon}
            </span>
        </button>
    );
}

IconButton.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf(["confirm", "ghost", "glass", "glass-strong"]),
    size: PropTypes.number,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    type: PropTypes.oneOf(["button", "submit", "reset"]),
};
